// src/components/Body.js
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "./styles/Body.css";
import ContactForm from "./ContactForm";

const SITE_URL = "https://elamuaudit.ee";
const LOGO_URL = `${SITE_URL}/logo.svg`;

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}/#business`,
  name: "Elamuaudit OÜ",
  url: SITE_URL,
  logo: LOGO_URL,
  image: LOGO_URL,
  telephone: "+3725098440",
  email: "urmas@elamuaudit.ee",
  priceRange: "€€",
  address: {
    "@type": "PostalAddress",
    addressCountry: "EE",
  },
  areaServed: {
    "@type": "Country",
    name: "Estonia",
  },
  description:
    "Elamuaudit OÜ pakub energiamärgise väljastamist, elamu- ja ühiskondlike hoonete energiaauditit, termopildistamist ning sisekliima mõõtmist.",
  employee: {
    "@type": "Person",
    name: "Urmas Paales",
    jobTitle: "Hoonete energiaaudiitor tase 7",
  },
  makesOffer: [
    { "@type": "Offer", itemOffered: { "@type": "Service", name: "Energiamärgis" } },
    { "@type": "Offer", itemOffered: { "@type": "Service", name: "Ühiskondliku hoone energiaaudit" } },
    { "@type": "Offer", itemOffered: { "@type": "Service", name: "Elamu energiaaudit" } },
    { "@type": "Offer", itemOffered: { "@type": "Service", name: "KredEx'i tehnilise konsultandi teenus" } },
    { "@type": "Offer", itemOffered: { "@type": "Service", name: "Termopildistamine" } },
    { "@type": "Offer", itemOffered: { "@type": "Service", name: "Sisekliima mõõtmine" } },
  ],
};

const TITLE = "Energiamärgis ja energiaaudit Eestis – Elamuaudit OÜ";
const DESCRIPTION =
  "Elamuaudit OÜ pakub energiamärgise väljastamist, elamu- ja ühiskondlike hoonete energiaauditit, termopildistamist ning sisekliima mõõtmist.";

function Body() {
  return (
    <main className="site-body">
      <Helmet>
        <title>{TITLE}</title>
        <meta name="description" content={DESCRIPTION} />
        <link rel="canonical" href={`${SITE_URL}/`} />

        <meta property="og:type" content="website" />
        <meta property="og:locale" content="et_EE" />
        <meta property="og:site_name" content="Elamuaudit OÜ" />
        <meta property="og:title" content={TITLE} />
        <meta property="og:description" content={DESCRIPTION} />
        <meta property="og:url" content={`${SITE_URL}/`} />
        <meta property="og:image" content={`${SITE_URL}/og-image.png`} />
        <meta property="og:image:width" content="1954" />
        <meta property="og:image:height" content="1026" />
        <meta property="og:image:alt" content="Elamuaudit OÜ – energiamärgis ja energiaaudit" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={TITLE} />
        <meta name="twitter:description" content={DESCRIPTION} />
        <meta name="twitter:image" content={`${SITE_URL}/og-image.png`} />

        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <section className="container content-section">
        <header className="intro center-text">
          <h1>Energiamärgis ja energiaaudit Eestis</h1>
          <p className="intro-tagline">Elamuaudit OÜ</p>
        </header>

        <section className="services">
          <h2>Teenused</h2>
          <ul>
            <li><Link to="/energiamargis">Energiamärgis</Link></li>
            <li>Ühiskondliku hoone energiaaudit</li>
            <li>Elamu energiaaudit</li>
            <li>KredEx&apos;i tehnilise konsultandi teenus</li>
            <li>Termopildistamine</li>
            <li>Sisekliima mõõtmine</li>
          </ul>
        </section>

        <section className="profile-section">
          <div className="profile-card">
            <p className="profile-name">Urmas Paales</p>
            <p className="profile-title">Hoonete energiaaudiitor tase 7 (osakutse)</p>
            <p className="profile-title">KredEx&apos;i tehniline konsultant</p>
            <div className="profile-contact">
              <a href="tel:+3725098440">+372 509 8440</a>
              <a href="mailto:urmas@elamuaudit.ee">urmas@elamuaudit.ee</a>
            </div>
          </div>
        </section>
      </section>

      <section className="cta-section" id="contact">
        <div className="cta-inner">
          <h2>Võtke meiega ühendust</h2>
          <div className="cta-form-wrapper">
            <ContactForm />
          </div>
        </div>
      </section>
    </main>
  );
}

export default Body;
